<template>
  <b-navbar-nav>
    <b-nav-item :to="{ name: 'Overview' }">Overview</b-nav-item>
    <b-nav-item :to="{ name: 'Officials' }">Officials</b-nav-item>
    <b-nav-dropdown text="Preparations">
      <b-dropdown-item :to="{ name: 'CheckIn' }">Check-In</b-dropdown-item>
      <b-dropdown-item :to="{ name: 'MedicalEvaluation' }">Medical Checks</b-dropdown-item>
      <b-dropdown-item :to="{ name: 'WeighIn' }">Weigh-In</b-dropdown-item>
    </b-nav-dropdown>
    <b-nav-item :to="{ name: 'Equipment' }">Equipment</b-nav-item>
    <b-nav-item :to="{ name: 'Setup' }">Setup</b-nav-item>
    <b-nav-item :to="{ name: 'Tournament' }">Tournament</b-nav-item>
    <b-nav-item :to="{ name: 'TVSchedule' }" target="_blank">TV Schedule</b-nav-item>
  </b-navbar-nav>
</template>

<script>
export default {
  name: 'NavBarLinks',
};
</script>
